export default __webpack_public_path__ + "static/media/3530.3db6f854.png";